import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchError, tap, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { CommsStatusService } from '../api/comms-status.service';

export const commsErrorInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.vigilantApiUrl)) return next(req);

  const commsStatus = inject(CommsStatusService);
  const snackBar = inject(MatSnackBar);

  return next(req).pipe(
    tap({ next: () => commsStatus.onSuccess() }),
    catchError((err: HttpErrorResponse) => {
      // 401 (unauthenticated) and 403 (forbidden / no account) are authorization
      // problems, not connectivity ones — don't trip the comms-blocked flow.
      if (err.status !== 401 && err.status !== 403) {
        const firstError = !commsStatus.isInError();
        commsStatus.onError();
        if (firstError) {
          snackBar.open('Connection error — retrying in 1 minute…', undefined, { duration: 6000 });
        }
      }
      return throwError(() => err);
    })
  );
};
